import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Modal } from '../../components/modals/Modal'
import { OnClickButton } from '../../components/buttons/onclick/OnClickButton'
import { BodyLarge, Title3 } from '../../components/styles/Typography'
import { theme } from '../../theme/theme'

type Props = {
  onConfirm: () => void
  onCancel: () => void
  loading: boolean
}

export const DeclinePolicyDialog = ({ onConfirm, onCancel, loading }: Props) => {
  const { t } = useTranslation()

  return (
    <Modal disableClose maxWidth="520px">
      <Title3>{t('common.dataPolicy.declineTitle')}</Title3>
      <Body>{t('common.dataPolicy.declineBody')}</Body>
      <Buttons>
        <OnClickButton
          secondary
          buttonColor={theme.color.red}
          text={t('common.dataPolicy.declineConfirm')}
          onClick={onConfirm}
          disabled={loading}
          loading={loading}
        />
        <OnClickButton text={t('common.dataPolicy.declineBack')} onClick={onCancel} disabled={loading} />
      </Buttons>
    </Modal>
  )
}

const Body = styled(BodyLarge)`
  margin: ${theme.spacing.xsmall}px 0 ${theme.spacing.mediumLarge}px;
  color: ${theme.color.grey5};
`

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.small}px;

  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    flex-direction: column-reverse;
  }
`
